import type { V2ConversationType } from '@/features/chat/types'

export type NewConversationContactType = {
  id: string
  name: string
  initials: string
  picture?: string | null
  // programme de la premiere conversation de groupe partagee : sert a creer la conversation privee
  programId: string
  groupNames: string[]
  existingConversationId: string | null
}

// Personnes avec qui l'utilisateur partage un groupe (tous programmes), triees
// par nom, avec la conversation privee deja ouverte s'il y en a une.
export function getNewConversationContacts(
  conversations: V2ConversationType[],
  currentUserId: string | undefined,
): NewConversationContactType[] {
  const contacts = new Map<string, NewConversationContactType>()

  for (const conversation of conversations) {
    if (!conversation.groupId || !conversation.programId) continue
    for (const user of conversation.users) {
      if (!user.id || user.id === currentUserId) continue
      const existing = contacts.get(user.id)
      if (existing) {
        if (conversation.groupName && !existing.groupNames.includes(conversation.groupName)) {
          existing.groupNames.push(conversation.groupName)
        }
        continue
      }
      const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()
      contacts.set(user.id, {
        id: user.id,
        name,
        initials: `${user.firstName?.[0] ?? ''}${user.lastName?.[0] ?? ''}`,
        picture: user.picture,
        programId: conversation.programId,
        groupNames: conversation.groupName ? [conversation.groupName] : [],
        existingConversationId: null,
      })
    }
  }

  for (const conversation of conversations) {
    if (conversation.groupId) continue
    const other = conversation.users.find((user) => user.id !== currentUserId)
    const contact = other && contacts.get(other.id)
    if (contact && conversation.users.length === 2 && !conversation.conversationId.startsWith('temp-')) {
      contact.existingConversationId = contact.existingConversationId ?? conversation.conversationId
    }
  }

  return [...contacts.values()].sort((a, b) => a.name.localeCompare(b.name))
}
